"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@cian/peperrors/shared");
var circuitBreaker_1 = require("../circuitBreaker");
var telemetryHelpers_1 = require("./telemetryHelpers");
var RequestTelemetry = /** @class */ (function () {
    function RequestTelemetry(_a) {
        var telemetry = _a.telemetry, host = _a.host, path = _a.path;
        this.telemetry = telemetry;
        this.telemetryKey = telemetryHelpers_1.getKey(host, path);
    }
    RequestTelemetry.prototype.onRequest = function () {
        this.startDate = Date.now();
    };
    RequestTelemetry.prototype.onResponse = function () {
        this.telemetry.timer(this.telemetryKey, this.timeDiff);
        this.telemetry.increment(this.telemetryKey + ".success");
    };
    RequestTelemetry.prototype.onError = function (error) {
        if (error instanceof circuitBreaker_1.CircuitBreakerError) {
            this.telemetry.increment(this.telemetryKey + ".fail.circuit_breaker");
            return;
        }
        if (error instanceof shared_1.HttpTimeoutError) {
            this.telemetry.timer(this.telemetryKey, this.timeDiff);
            this.telemetry.increment(this.telemetryKey + ".fail.timeout");
            return;
        }
        if (error instanceof shared_1.HttpBadStatusCodeError) {
            this.telemetry.timer(this.telemetryKey, this.timeDiff);
            this.telemetry.increment(this.telemetryKey + ".fail.http_error_" + error.statusCode);
            return;
        }
        this.telemetry.increment(this.telemetryKey + ".fail.error_" + telemetryHelpers_1.normalize(error.message));
    };
    Object.defineProperty(RequestTelemetry.prototype, "timeDiff", {
        get: function () {
            return Date.now() - this.startDate;
        },
        enumerable: true,
        configurable: true
    });
    return RequestTelemetry;
}());
exports.RequestTelemetry = RequestTelemetry;
//# sourceMappingURL=requestTelemetry.js.map